import { NavLink } from 'react-router-dom';
import { Server, ServerCrash } from 'lucide-react';
import { useActiveGroupCapabilities } from '@/stores/gameGroups.store';
import { satelliteServes } from '@/config/panelModules';
import styles from './ServerTabs.module.scss';

/**
 * Barre d'onglets de l'espace « Server » : liste des serveurs et crashs serveur.
 * Utilisée en tête de ConsolePage (/console) et WatchdogPage (/console/crashs).
 * « Crashs serveur » est masqué sous un groupe dont le satellite n'a pas le module watchdog
 * (config/panelModules) ; capacités inconnues (Paladium, groupes pas encore lus) : affiché.
 */
export function ServerTabs() {
  const capabilities = useActiveGroupCapabilities();
  const showCrashs = satelliteServes('/console/crashs', capabilities);
  const linkClass = ({ isActive }: { isActive: boolean }) =>
    `${styles.tab} ${isActive ? styles.active : ''}`;

  return (
    <nav className={styles.tabs}>
      <NavLink to="/console" end className={linkClass}>
        <Server size={16} strokeWidth={2} />
        <span>Serveurs</span>
      </NavLink>
      {showCrashs && (
        <NavLink to="/console/crashs" className={linkClass}>
          <ServerCrash size={16} strokeWidth={2} />
          <span>Crashs serveur</span>
        </NavLink>
      )}
    </nav>
  );
}
